<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#ff4343" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 px-0 py-2>
        <v-card flat rounded="xl" outlined>
          <v-layout pt-4 px-4 wrap justify-end>
            <v-flex xs12 sm9 md7 xl9 text-left>
              <span
                style="
                  font-family: opensansbold;
                  font-size: 25px;
                  color: #808080;
                "
              >
                Previous Orders
              </span>
            </v-flex>
            <v-flex xs6 sm3 md5 xl3 text-right align-self-center>
              <router-link to="/Seller/SoldProducts">
                <span
                  style="
                    font-family: opensanslight;
                    font-size: 14px;
                    color: #041c4b;
                    cursor: pointer;
                  "
                >
                  View More...
                </span>
              </router-link>
            </v-flex>
          </v-layout>
          <v-layout pt-2 wrap justify-center>
            <v-flex xs12 px-2 py-2 v-for="(item, i) in storage" :key="i">
              <v-card flat rounded="xl" color="#F5F7FC" outlined>
                <v-layout px-sm-4 wrap justify-center>
                  <v-flex xs12>
                    <v-layout wrap justify-center>
                      <v-flex xs3 lg3 xl3 pa-2>
                        <v-img
                          :src="mediaURL + item.productId.photos[0]"
                          height="100px"
                          contain
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="#FF4343"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-flex>
                      <v-flex xs9 lg9 xl9 style="line-height: 20px">
                        <v-layout wrap justify-center>
                          <v-flex xs12 text-left pt-2>
                            <span style="cursor: pointer;" @click="checkProduct(item.productId._id)">
                              <span
                                style="
                                  font-family: opensansbold;
                                  font-size: 16px;
                                  color: #808080;
                                "
                              >
                                {{ item.productname.slice(0, 25) }}
                                <span v-if="item.productname.length > 25">
                                  ...
                                </span>
                              </span>
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left>
                            <span
                              style="
                                font-family: opensansbold;
                                font-size: 14px;
                                color: #000000;
                              "
                            >
                              Price: ₹{{ item.offerPrice }}
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left>
                            <!-- <span
                              style="
                                font-family: opensanssemibold;
                                font-size: 14px;
                                color: #000000;
                              "
                            >
                              Shipped
                            </span> -->
                            <span
                              style="
                                font-family: opensanslight;
                                font-size: 12px;
                                color: #000000;
                              "
                            >
                              {{ formatDate(item.create_date) }}
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left>
                            <span
                              style="
                                font-family: opensansregular;
                                font-size: 12px;
                                color: #188320;
                              "
                            >
                              Stock: {{ item.productId.quantity }} Pieces
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      sortItems: [
        { name: "Today", value: "Today" },
        { name: "Yesterday", value: "Yesterday" },
        { name: "This Week", value: "This Week" },
      ],
      sortItem: "Today",
      showSnackBar: false,
      msg: "",
      timeout: 5000,
    };
  },
  methods: {
    checkProduct(id) {
      axios({
        method: "POST",
        url: "product/view",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status === false) {
            this.msg = "Faild to find the product";
            this.showSnackBar = true;
          } else {
            this.$router.push("/Seller/Product/" + id);
          }
        })
        .catch((err) => {
          this.$router.push("/ServerError");
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      day = day < 10 ? "0" + day : day;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
